module.exports = __webpack_public_path__ + "img/delete-round.0b59bc5a.svg";